const School = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer4"
      d="M8 27.917a1 1 0 0 1-1-1V6.316c0-.552 2-.552 2 0v20.6a1 1 0 0 1-1 1.001z"
      fill={color}
    ></path>
    <path
      data-name="layer3"
      fill={color}
      d="M60.002 5.916L32 1.917 4 5.916l14.002 3v7l14 2 14-2v-7l14-3z"
    ></path>
    <path
      data-name="layer2"
      d="M49.578 51.083A8.3 8.3 0 0 0 48 50.918l-16 11h30s0-8.432-12.422-10.835zm-35.156 0A8.3 8.3 0 0 1 16 50.918l16 11H2s0-8.432 12.422-10.835zM32 11.916l-28-6 28-3.999 28.002 3.999-28.002 6z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M44.769 31.783c3.023-.037 3.73-4.257 3.73-5.2s.517-4.6-2.5-4.653v-6.012h-.006L32 17.916l-13.994-2H18v6.011c-3.014.054-2.5 3.715-2.5 4.653s.707 5.164 3.73 5.2A17.426 17.426 0 0 0 25 40.92v3c0 1.9.107 5-9 7l16 11 16-11c-9.108-2-9-5.1-9-7v-3a17.427 17.427 0 0 0 5.769-9.137z"
      fill="#ececec"
    ></path>
    <g opacity=".15">
      <path
        d="M39 40.92l-.115.115c.075-.071.115-.115.115-.115zm-22.985 9.994a29.037 29.037 0 0 0 3.906-1.119z"
        fill="#000064"
      ></path>
      <path
        d="M32 1.918l-28 4 3 .643v20.356a1 1 0 1 0 2 0V6.987l9 1.929v7h-.006v6.011c-3.014.054-2.5 3.715-2.5 4.653s.707 5.164 3.73 5.2A17.426 17.426 0 0 0 25 40.92v3.369c-.018 1.559-.33 3.739-5.078 5.508a29.212 29.212 0 0 1-3.911 1.121h-.016a8.3 8.3 0 0 0-1.578.166C2 53.486 2 61.918 2 61.918h16l20.887-20.883A10.413 10.413 0 0 1 32 43.92z"
        fill="#000064"
      ></path>
    </g>
  </svg>
);

export default School;
